module.exports = __webpack_public_path__ + "images/df8915c3ebb7d37b33e9ca5368232d1f-caro8.jpg";